import * as React from 'react';

import PortfolioProjectContent from 'bundles/unified-description-page-common/components/modules/project-content/PortfolioProjectContent';
import ProjectContentModule from 'bundles/unified-description-page-common/components/modules/project-content/ProjectContentModule';
import InstructorAndPartnerInfo from 'bundles/unified-description-page-common/components/shared/InstructorAndPartnerInfo';
import TogglableDescription from 'bundles/unified-description-page-common/components/shared/TogglableDescription';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import { PROJECT_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import _t from 'i18n!nls/xdp';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
};

const PortfolioProjectContentModuleRenderer = ({ pageData }: Props) => {
  return (
    <ProjectContentModule
      title={_t('About this Project')}
      description={pageData.cmlLearningObjectives && <TogglableDescription description={pageData.description} />}
      anchorId={PROJECT_NAV_ITEMS.DETAILS}
      content={<PortfolioProjectContent cmlTasks={pageData.projectMetadata?.cmlTasks} />}
      sidebar={<InstructorAndPartnerInfo partners={pageData.partners} trackingLocation="syllabus" />}
    />
  );
};

export default PortfolioProjectContentModuleRenderer;
